/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./usdLucky.vue?vue&type=template&id=ec2c2f1a&scoped=true"
import script from "./usdLucky.vue?vue&type=script&lang=js"
export * from "./usdLucky.vue?vue&type=script&lang=js"
import style0 from "./usdLucky.vue?vue&type=style&index=0&id=ec2c2f1a&prod&lang=scss"
import style1 from "./usdLucky.vue?vue&type=style&index=1&id=ec2c2f1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2c2f1a",
  null
  
)

export default component.exports